<!-- eslint-disable -->
<template>
  <span id='reports'>
    <div class="md-layout">
      <!-- Card de Média das Avaliações com Estrelas -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20">
        <DataProvider :endpoint='mountUrlAndParams("averageAttendedRatings").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("averageAttendedRatings").filter'
                      @success='mountChartData("averageAttendedRatings", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="blue">
              <template slot="header">
                <div class="card-icon">
                  <i class="far fa-star"></i>
                </div>
                <p class="category">{{ $t('efficiency.averageOfStarRatings') }}</p>
                <h3 class="title">
                  <div>
                    <animated-number
                      isDecimal
                      :value='dataObj.averageAttendedRatings'
                    ></animated-number>
                  </div>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Card de Informação Encontrada-->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20" v-if="!isYara">
        <DataProvider :endpoint='mountUrlAndParams("foundInformation").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("foundInformation").filter'
                      @success='mountChartData("foundInformation", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="rose">
              <template slot="header">
                <div class="card-icon">
                  <i class="fas fa-search"></i>
                </div>
                <p class="category">{{ $t('efficiency.informationFound') }}</p>
                <h3 class="title">
                  <div>
                    <animated-number
                      :value='dataObj.foundInformation'
                    ></animated-number>
                  </div>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Card de Informação Não Encontrada -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20" v-if="!isYara">
        <DataProvider :endpoint='mountUrlAndParams("notFoundInformation").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("notFoundInformation").filter'
                      @success='mountChartData("notFoundInformation", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="green">
              <template slot="header">
                <div class="card-icon">
                  <i class="fas fa-search"></i>
                </div>
                <p class="category">{{ $t('efficiency.informationNotFound') }}</p>
                <h3 class="title">
                  <div>
                    <animated-number
                      :value='dataObj.notFoundInformation'
                    ></animated-number>
                  </div>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Quantidade de conversas encerradas por inatividade -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20">
        <DataProvider :endpoint='mountUrlAndParams("amountEndConversationByUserOrInactive").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("amountEndConversationByUserOrInactive").filter'
                      @success='mountChartData("amountEndConversationByUserOrInactive", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="warning">
              <template slot="header">
                <div class="card-icon">
                  <i class="far fa-comments"></i>
                </div>
                <p class="category">{{ $t('efficiency.conversationsEndedByInactivity') }}</p>
                <h3 class="title">
                  <div>
                    <animated-number
                      :value='dataObj.amountEndConversationByInactive'
                    ></animated-number>
                  </div>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Quantidade de conversas encerradas pelo usuário -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20">
        <DataProvider :endpoint='mountUrlAndParams("amountEndConversationByUserOrInactive").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("amountEndConversationByUserOrInactive").filter'
                      @success='mountChartData("amountEndConversationByUserOrInactive", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="teal">
              <template slot="header">
                <div class="card-icon">
                  <i class="far fa-user"></i>
                </div>
                <p class="category">{{ $t('efficiency.userEndedConversations') }}</p>
                <h3 class="title">
                  <div>
                    <animated-number
                      :value='dataObj.amountEndConversationByUser'
                    ></animated-number>
                  </div>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Gráfico Quantidade de Acessos por Item de Menu Principal -->
      <div class="md-layout-item md-size-100 mx-auto">
        <DataProvider :endpoint='mountUrlAndParams("amountAccessByMainMenu").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("amountAccessByMainMenu").filter'
                      @success='mountChartData("amountAccessByMainMenu", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              style='margin: 30px 0;'
              type="card-heading, list-item-three-line, list-item-three-line, list-item-three-line"
            >
            </v-skeleton-loader>
            <template v-else-if='error || dataObj.amountAccessByMainMenu.data.series[0].length === 0'>
              <CardNoData :title="$t('efficiency.numberOfAccessesMainMenuItem')" :error='error' height='463'/>
            </template>
            <chart-card
              v-else
              header-animation="false"
              :chart-data="dataObj.amountAccessByMainMenu.data"
              :chart-options="dataObj.amountAccessByMainMenu.options"
              chart-type="Bar"
              header-icon
              chart-inside-content
              no-footer
              background-color="green"
              style='padding-right: 100px;'
              classNameComponent="efficiencyChart"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{ $t('efficiency.numberOfAccessesMainMenuItem') }}</h4>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>


      <!-- Grafíco de Linhas para a métrica de informação encontrada e não encontrada  -->
      <div class="md-layout-item md-size-50" v-if="false">
        <DataProvider :endpoint='mountUrlAndParams("amountInformationFoundAndNotFound").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("amountInformationFoundAndNotFound").filter'
                      @success='mountChartData("amountInformationFoundAndNotFound", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else>
              <!-- <template v-if='error || dataObj.amountInformationFoundAndNotFound.data.series[0].length === 0'>
                <CardNoData title='Métrica de informação encontrada e não encontrada' :error='error' height='463' />
              </template> -->
              <chart-card

                header-animation="false"
                :chart-data="dataObj.amountInformationFoundAndNotFound.data"
                :chart-options="dataObj.amountInformationFoundAndNotFound.options"
                chart-type="Line"
                header-icon
                chart-inside-content
                no-footer
                background-color="green"
                classNameComponent="efficiencyChart"
              >
                <template slot="chartInsideHeader">
                  <h4 class="title">{{ $t('efficiency.metricOfInformationFoundNotFound') }}</h4>
                </template>
              </chart-card>
            </template>
          </div>
        </DataProvider>
      </div>

      <!-- Gráfico para Percentual de Informação Encontrada / Não Encontrada por Item do Menu Principal -->
      <div class="md-layout-item md-size-100" v-if="!isYara">
        <DataProvider :endpoint='mountUrlAndParams("percentInformationFoundByMainMenu").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("percentInformationFoundByMainMenu").filter'
                      @success='mountChartData("percentInformationFoundByMainMenu", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else>
              <template v-if='error || dataObj.percentInformationFoundByMainMenu.data.series[0].length === 0'>
                <CardNoData :title="$t('efficiency.percentageOfInformationFoundNotFound')" :error='error' height='463'/>
              </template>
              <chart-card
                v-else
                header-animation="false"
                :chart-data="dataObj.percentInformationFoundByMainMenu.data"
                :chart-options="dataObj.percentInformationFoundByMainMenu.options"
                chart-type="Bar"
                horizontal-bars="true"
                header-icon
                chart-inside-content
                background-color="green"
                classNameComponent="efficiencyChart"
              >
                <template slot="chartInsideHeader">
                  <h4 class="title">{{ $t('efficiency.percentageOfInformationFoundNotFound') }}</h4>
                </template>
                <template slot="footer">
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <span>
                        <i class="fa fa-circle color-green-50"></i>
                          {{ $t('efficiency.yes') }}
                      </span>
                      <span>
                        <i class="fa fa-circle color-green-olive"></i>
                          {{ $t('efficiency.no') }}
                      </span>
                    </div>
                  </div>
                </template>
              </chart-card>
            </template>
          </div>
        </DataProvider>
      </div>

      <!-- Nuvens de palavras -->
      <div class="md-size-50 md-layout-item" v-if="false">
        <DataProvider :endpoint='mountUrlAndParams("notFoundInformationCloudWords").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("notFoundInformationCloudWords").filter'
                      @success='mountChartData("notFoundInformationCloudWords", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else-if='error || dataObj.notFoundInformationCloudWords.words.length === 0'>
              <CardNoData :title="$t('efficiency.whatArePeopleFailingToFind')" :error='error' height='508'/>
            </template>
            <chart-card
              v-else
              header-animation="false"
              header-icon
              no-footer
              background-color="green"
              :isChart='false'
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{ $t('efficiency.whatArePeopleFailingToFind') }}</h4>
                <cloud
                  :data="dataObj.notFoundInformationCloudWords.words"
                  :fontSizeMapper="dataObj.notFoundInformationCloudWords.fontSizeMapper"
                  :height="tenant == 'regularize' ? 383: 400"
                  :width="600"
                  :rotate="dataObj.notFoundInformationCloudWords.rotate"
                  :padding="6"
                  :onWordClick="(word) => {}"
                >
                </cloud>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>

      <!-- Gráfico para Percentual de Informação Encontrada / Não Encontrada por Item do Submenu -->
      <div class="md-layout-item md-size-50" v-if="false">
        <DataProvider :endpoint='mountUrlAndParams("percentInformationFoundBySubmenu").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("percentInformationFoundBySubmenu").filter'
                      @success='mountChartData("percentInformationFoundBySubmenu", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else>
              <template v-if='error || dataObj.percentInformationFoundBySubmenu.data.series[0].length === 0'>
                <CardNoData :title="$t('efficiency.percentageInformationFoundNotFoundSubmenuItem')" :error='error'
                            height='463'/>
              </template>
              <chart-card
                v-else
                header-animation="false"
                :chart-data="dataObj.percentInformationFoundBySubmenu.data"
                :chart-options="dataObj.percentInformationFoundBySubmenu.options"
                chart-type="Bar"
                horizontal-bars="true"
                header-icon
                chart-inside-content
                background-color="green"
                classNameComponent="efficiencyChart"
              >
                <template slot="chartInsideHeader">
                  <h4 class="title">{{ $t('efficiency.percentageInformationFoundNotFoundSubmenuItem') }}</h4>
                </template>
                <template slot="footer">
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <span>
                        <i class="fa fa-circle color-green-olive"></i>
                          {{ $t('efficiency.yes') }}
                      </span>
                      <span>
                        <i class="fa fa-circle color-green-50"></i>
                          {{ $t('efficiency.no') }}
                      </span>
                    </div>
                  </div>
                </template>
              </chart-card>
            </template>
          </div>
        </DataProvider>
      </div>

      <!-- Gráfico para Percentual de Informação Encontrada / Não Encontrada por Item do Submenu -->
      <div class="md-layout-item md-size-50 mx-auto " v-if="false">
        <DataProvider :endpoint='mountUrlAndParams("amountAccessBySubmenu").url' baseUrl='/placeholder'
                      :filter='mountUrlAndParams("amountAccessBySubmenu").filter'
                      @success='mountChartData("amountAccessBySubmenu", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              style='margin: 30px 0;'
              type="card-heading, list-item-three-line, list-item-three-line, list-item-three-line"
            >
            </v-skeleton-loader>
            <template v-else-if='error || dataObj.amountAccessBySubmenu.data.series[0].length === 0'>
              <CardNoData :title="$t('efficiency.numberAccessesSubmenuItem')" :error='error' height='463'/>
            </template>
            <chart-card
              v-else
              header-animation="false"
              :chart-data="dataObj.amountAccessBySubmenu.data"
              :chart-options="dataObj.amountAccessBySubmenu.options"
              chart-type="Bar"
              header-icon
              chart-inside-content
              no-footer
              background-color="green"
              style='padding-right: 100px;'
              classNameComponent="efficiencyChart"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{ $t('efficiency.numberAccessesSubmenuItem') }}</h4>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>
      <div v-if="isYara" class="md-layout-item" style="padding: 0px">
        <div class="ml-auto" style="padding-right: 14px">
          <md-button class="md-warning" style="float: right;" @click="openCreateAbandonmentReportModal()">
            <v-icon style="color: black !important; padding-right: 4px;">mdi-plus</v-icon>
            <span style="color: black"> {{ $t("efficiency.createReport") }} </span>
          </md-button>
        </div>
        <DataProvider id="dataTable" ref="dataProviderReport" :endpoint='mountUrlAndParams("abandonmentReports").url'
                      :filter='mountUrlAndParams("abandonmentReports").filter'>
          <div slot-scope="{ data: response, error, loading }">
            <DataTable
              :data='response && response.data'
              :title="$t('efficiency.abandonmentReportLabel')"
              :customTotal='(response && response.total) || 0'
              customIcon="mdi-message-alert-outline"
              :loading="false"
              customHeader
              @pagination='handlePagination'
              :buttonHeaders="false"
              :selectable='false'
              :exclude-top-pagination='true'
              :labels="labels"
              :endpoint='mountUrlAndParams("abandonmentReports").url'
              :filter='mountUrlAndParams("abandonmentReports").filter'
              :perPage='filter.perPage'
            >
              <template slot="cells" slot-scope="{ item }">
                <md-table-cell :md-label="labels[0]">
                  {{ formatLabels(item, 0) }}
                  <md-tooltip md-direction="bottom"
                              v-if="item._source.errorMessage">{{ item._source.errorMessage }}</md-tooltip>
                </md-table-cell>
                <md-table-cell :md-label="labels[1]">{{ formatLabels(item, 1) }} </md-table-cell>
                <md-table-cell :md-label="labels[2]">{{ formatLabels(item, 2) }}</md-table-cell>
                <md-table-cell :md-label="labels[3]">{{ formatLabels(item, 3) }}</md-table-cell>
                <md-table-cell :md-label="labels[4]">
                  <v-btn
                    class="mx-2"
                    depressed x-small fab
                    color="#31A44C"
                    @click="generateCSV(item._id)"
                    :disabled="item._source.status !== 'completed'"
                  >
                    <ArrowDown fill="white" style="width: 18px; height:18px;"/>
                  </v-btn>
                </md-table-cell>
              </template>
              <template slot="footer" slot-scope='{ pagination }'>
                <v-row style="justify-content: flex-end;">
                  <v-col cols="auto">
                    <md-field>
                      <label for="pages">{{ $t('assistantsList.perPage') }}</label>
                      <md-select v-model="pagination.perPage" name="pages">
                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item"
                                   :value="item">{{ item }}</md-option>
                      </md-select>
                    </md-field>
                  </v-col>
                </v-row>
              </template>
            </DataTable>
          </div>
        </DataProvider>
        <VueJsonToCsv :id="csvComponentId" :json-data="csvData" :csv-title="csvName" :labels="csvLabel"
                      style="opacity: 0; pointer-events: none;"></VueJsonToCsv>
        <CreateAbandonmentReportsModal
          :displayModal='displayAbandonmentReport'
          @close="closeModal"
          @reportCreated="startPulling"
        />
      </div>
    </div>
  </span>
</template>

<script>
import Cloud from 'vue-d3-cloud'
import { mapFields } from 'vuex-map-fields'
import AnimatedNumber from '@/components/AnimatedNumber'
import ChartCard from '@/components/Cards/ChartCard.vue'
import StatsCard from '@/components/Cards/StatsCard.vue'
import DataProvider from '@/components/DataProvider'
import DataTable from '@/components/DataTable'
import ArrowDown from '@/assets/img/tray-arrow-down.svg'
import SkeletonLoaderChart from '@/components/Reuse/SkeletonLoaderChart'
import CardNoData from '@/components/CardNoData'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import CreateAbandonmentReportsModal from '@/components/CreateAbandonmentReportsModal'
import * as moment from 'moment'
import Swal from 'sweetalert2'
import VueJsonToCsv from 'vue-json-to-csv'

let qtdConversationsHourWeek = {
  labels: [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23'
  ],

  series: [
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 0 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 1 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 1 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 0 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 3 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 1 },
      { meta: '7h', value: 10 },
      { meta: '8h', value: 1 },
      { meta: '9h', value: 3 },
      { meta: '10h', value: 2 },
      { meta: '11h', value: 1 },
      { meta: '12h', value: 3 },
      { meta: '13h', value: 2 },
      { meta: '14h', value: 1 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 2 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 1 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 2 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 0 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 0 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 0 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ]
  ]
}

export default {
  components: {
    StatsCard,
    ChartCard,
    AnimatedNumber,
    cloud: Cloud,
    DataProvider,
    DataTable,
    ArrowDown,
    VueJsonToCsv,
    SkeletonLoaderChart,
    CardNoData,
    CreateAbandonmentReportsModal
  },
  computed: {
    ...mapFields('reports', ['dateInterval'])
  },
  watch: {
    dateInterval: {
      deep: true,
      handler (nV) {
      }
    }
  },
  data () {
    return {
      tenant: '',
      baseURL: '',
      // date Interval
      chatDate: {
        d1: new Date().toISOString().substr(0, 10),
        d2: new Date().toISOString().substr(0, 10),
        t1: null,
        t2: null
      },
      dataObj: {
        allConversations: 0,
        averageAttendedRatings: 0,
        foundInformation: 0,
        notFoundInformation: 0,
        amountEndConversationByInactive: 0,
        amountEndConversationByUser: 0,
        allInteractions: 0,
        agvTimeConversation: 0,
        avgInteraction: 0,
        amountInformationFoundAndNotFound: {
          data: {
            labels: ['14/01', '15/01', '20/02', '01/04'],
            series: [
              [
                { meta: '14/01', value: 2 },
                { meta: '15/01', value: 11 },
                { meta: '20/02', value: 3 },
                { meta: '01/04', value: 18 }
              ],
              [
                { meta: '14/01', value: 5 },
                { meta: '15/01', value: 15 },
                { meta: '20/02', value: 8 },
                { meta: '01/04', value: 25 }
              ]
            ]
          },
          options: {
            height: 400,
            lineSmooth: this.$Chartist.Interpolation.cardinal({
              tension: 1
            }),
            classNames: {
              line: 'customLine'
            },
            plugins: [
              this.$chartist.plugins
                .tooltip({
                  anchorToPoint: true,
                  seriesName: true,
                  tooltipFnc: this.mountTooltip
                })
                .bind(this),
              this.$chartist.plugins
                .ctPointLabels({
                  textAnchor: 'middle',
                  labelInterpolationFnc: (value) => {
                    if (typeof value === 'undefined') return ''; else return value
                  }
                })
                .bind(this)
            ]
          }
        },
        percentInformationFoundByMainMenu: {
          data: {
            labels: ['14/01', '15/01', '20/02', '01/04'],
            series: [
              [
                { meta: '14/01', value: 2 },
                { meta: '15/01', value: 11 },
                { meta: '20/02', value: 3 },
                { meta: '01/04', value: 18 }
              ],
              [
                { meta: '14/01', value: 5 },
                { meta: '15/01', value: 15 },
                { meta: '20/02', value: 8 },
                { meta: '01/04', value: 25 }
              ]
            ]
          },
          options: {
            height: 400,
            seriesBarDistance: 15,
            reverseData: false,
            horizontalBars: true,
            labelDirection: 'explode',
            axisX: {
              showGrid: false,
              onlyInteger: true
            },
            axisY: {
              offset: 170
            },
            plugins: [
              this.$chartist.plugins
                .tooltip({
                  anchorToPoint: true,
                  seriesName: true,
                  tooltipFnc: this.mountTooltip
                })
                .bind(this),
              this.$chartist.plugins
                .ctBarLabels({
                  labelOffset: {
                    x: 4
                  }
                })
                .bind(this)
            ]
          }
        },
        percentInformationFoundBySubmenu: {
          data: {
            labels: ['14/01', '15/01', '20/02', '01/04'],
            series: [
              [
                { meta: '14/01', value: 2 },
                { meta: '15/01', value: 11 },
                { meta: '20/02', value: 3 },
                { meta: '01/04', value: 18 }
              ],
              [
                { meta: '14/01', value: 5 },
                { meta: '15/01', value: 15 },
                { meta: '20/02', value: 8 },
                { meta: '01/04', value: 25 }
              ]
            ]
          },
          options: {
            height: 300,
            seriesBarDistance: 20,
            reverseData: false,
            horizontalBars: true,
            labelDirection: 'explode',
            axisX: {
              showGrid: false,
              onlyInteger: true
            },
            axisY: {
              offset: 170
            },
            plugins: [
              this.$chartist.plugins
                .tooltip({
                  anchorToPoint: true,
                  seriesName: true,
                  tooltipFnc: this.mountTooltip
                })
                .bind(this),
              this.$chartist.plugins
                .ctBarLabels({
                  labelOffset: {
                    x: 4
                  }
                })
                .bind(this)
            ]
          }
        },
        qtyConversationsHourWeek: {
          data: {
            labels: qtdConversationsHourWeek.labels,
            series: qtdConversationsHourWeek.series
          },
          options: {
            height: 400,
            stackBars: true,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value + 'h'
              }
            },
            axisY: {
              onlyInteger: true,
              labelInterpolationFnc: function (value) {
                return value
              }
            },
            plugins: [
              this.$chartist.plugins
                .tooltip({
                  anchorToPoint: true,
                  seriesName: true,
                  tooltipFnc: this.mountTooltip
                })
                .bind(this),
              this.$chartist.plugins
                .ctBarLabels({
                  labelOffset: {
                    y: -4
                  }
                })
                .bind(this)
            ]
          }
        },
        amountAccessByMainMenu: {
          data: {
            labels: [
              this.$t('efficiency.reportLeak'),
              this.$t('efficiency.reportLackOfWaterAbcdef'),
              this.$t('efficiency.generalGreetings'),
              this.$t('efficiency.consultRegistrationCpf'),
              this.$t('efficiency.waterQuality')
            ],
            series: [
              [
                { meta: this.$t('efficiency.reportLeak'), value: 1 },
                { meta: this.$t('efficiency.reportLackOfWaterAbcdef'), value: 3 },
                { meta: this.$t('efficiency.generalGreetings'), value: 1 },
                { meta: this.$t('efficiency.consultRegistrationCpf'), value: 1 },
                { meta: this.$t('efficiency.waterQuality'), value: 1 }
              ]
            ]
          },
          options: {
            height: 400,
            seriesBarDistance: 20,
            reverseData: false,
            horizontalBars: true,
            labelDirection: 'explode',
            axisX: {
              showGrid: false,
              onlyInteger: true
            },
            axisY: {
              offset: 170,
              labelInterpolationFnc: function ellipsisLabel (
                value,
                index,
                chart
              ) {
                const max = 25
                const textWidth = function (str) {
                  let thinChars =
                    str.length - str.replace(/[|^|i|I|l|1|.|,|'|]/g, '').length
                  return str.length - Math.ceil(thinChars / 2)
                }
                if (textWidth(value) <= max) return value

                // Start by chopping off at the word before max
                // This is an over-approximation due to thin-characters...
                let end = value.lastIndexOf(' ', max - 3)

                // Just one long word. Chop it off.
                if (end === -1) return value.substring(0, max - 3) + '...'

                // Step forward as long as textWidth allows.
                let newEnd = end
                do {
                  end = newEnd
                  newEnd = value.indexOf(' ', end + 1)

                  // No more spaces.
                  if (newEnd === -1) newEnd = value.length
                } while (textWidth(value.substring(0, newEnd) + '...') < max)
                return value.substring(0, end) + '...'
              }
            },
            plugins: [
              this.$chartist.plugins
                .tooltip({
                  anchorToPoint: true,
                  seriesName: true,
                  tooltipFnc: this.mountTooltip
                })
                .bind(this),
              this.$chartist.plugins
                .ctBarLabels({
                  labelOffset: {
                    x: 4
                  }
                })
                .bind(this)
            ]
          }
        },
        amountAccessBySubmenu: {
          data: {
            labels: [
              this.$t('efficiency.reportLeak'),
              this.$t('efficiency.reportLackOfWaterAbcdef'),
              this.$t('efficiency.generalGreetings'),
              this.$t('efficiency.consultRegistrationCpf'),
              this.$t('efficiency.waterQuality')
            ],
            series: [
              [
                { meta: this.$t('efficiency.reportLeak'), value: 1 },
                { meta: this.$t('efficiency.reportLackOfWaterAbcdef'), value: 3 },
                { meta: this.$t('efficiency.generalGreetings'), value: 1 },
                { meta: this.$t('efficiency.consultRegistrationCpf'), value: 1 },
                { meta: this.$t('efficiency.waterQuality'), value: 1 }
              ]
            ]
          },
          options: {
            height: 400,
            seriesBarDistance: 10,
            reverseData: false,
            horizontalBars: true,
            labelDirection: 'explode',
            classNames: {
              labels: 'ct-label-custom-a',
              bar: 'ct-bar-custom-a'
            },
            axisX: {
              showGrid: false,
              onlyInteger: true
            },
            axisY: {
              offset: 170,
              labelInterpolationFnc: function ellipsisLabel (
                value,
                index,
                chart
              ) {
                const max = 25
                const textWidth = function (str) {
                  let thinChars =
                    str.length - str.replace(/[|^|i|I|l|1|.|,|'|]/g, '').length
                  return str.length - Math.ceil(thinChars / 2)
                }
                if (textWidth(value) <= max) return value

                // Start by chopping off at the word before max
                // This is an over-approximation due to thin-characters...
                let end = value.lastIndexOf(' ', max - 3)

                // Just one long word. Chop it off.
                if (end === -1) return value.substring(0, max - 3) + '...'

                // Step forward as long as textWidth allows.
                let newEnd = end
                do {
                  end = newEnd
                  newEnd = value.indexOf(' ', end + 1)

                  // No more spaces.
                  if (newEnd === -1) newEnd = value.length
                } while (textWidth(value.substring(0, newEnd) + '...') < max)
                return value.substring(0, end) + '...'
              }
            },
            plugins: [
              this.$chartist.plugins
                .tooltip({
                  anchorToPoint: true,
                  seriesName: true,
                  tooltipFnc: this.mountTooltip
                })
                .bind(this),
              this.$chartist.plugins
                .ctBarLabels({
                  labelOffset: {
                    x: 4
                  }
                })
                .bind(this)
            ]
          }
        },
        notFoundInformationCloudWords: {
          words: [],
          fontSizeMapper: (word) => Math.log2(word.value + 1) * 8,
          rotate: (word) => word.value % 1
        },
        channel: {
          data: {
            series: [
              { meta: 'WebChat', value: 20 },
              { meta: 'Telegram', value: 10 },
              { meta: 'Facebook', value: 30 },
              { meta: 'WhatsApp', value: 40 },
              { meta: 'WhatsApp', value: 40 },
              { meta: 'WhatsApp', value: 40 },
              { meta: 'WhatsApp', value: 40 }
            ],
            label: ['WebChat', 'Facebook', 'WhatsApp', 'Telegram', 'WhatsApp', 'WhatsApp', 'WhatsApp']
          },
          options: {
            labels: ['WebChat', 'Facebook', 'WhatsApp', 'Telegram', 'WhatsApp', 'WhatsApp', 'WhatsApp'],
            donut: true,
            donutWidth: 50,
            fullWidth: true,
            height: 345,
            showLabel: true,
            classNames: {
              label: 'customLabel'
            },
            plugins: [
              this.$chartist.plugins
                .tooltip({
                  anchorToPoint: true,
                  seriesName: true,
                  tooltipFnc: this.mountTooltip
                })
                .bind(this)
            ]
          }
        },
        os: {
          data: {
            series: [{ meta: 'Windows', value: 23 }, { meta: 'iOS', value: 31 }, {
              meta: 'Android',
              value: 2
            }, { meta: 'Linux', value: 40 }]
          },
          options: {
            labels: ['Android', 'iOS', 'Windows', 'Linux'],
            donut: true,
            donutWidth: 50,
            fullWidth: true,
            height: 300,
            showLabel: true,
            classNames: {
              label: 'customLabel'
            },
            plugins: [
              this.$chartist.plugins
                .tooltip({
                  anchorToPoint: true,
                  seriesName: true,
                  tooltipFnc: this.mountTooltip
                })
                .bind(this)
            ]
          }
        }
      },
      filter: {
        order: 'desc',
        page: 0,
        perPage: 5
      },
      labels: [
        this.$t('usersList.status'),
        this.$t('commonWords.createdAt'),
        this.$t('commonWords.createdBy'),
        this.$t('efficiency.reportName'),
        this.$t('commonWords.actions')
      ],
      csvData: [],
      csvName: null,
      csvComponentId: 'csv-component-report',
      interval: null,
      displayAbandonmentReport: false,
      csvLabel: {
        date: { title: 'Data' },
        userName: { title: 'Usuário' },
        businessArea: { title: 'Área de Negócio' },
        tema: { title: 'Tema' },
        subTema: { title: 'Subtema' },
        hasCompletedFlow: { title: 'Fluxo de conversa Completo' }
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    startPulling () {
      this.interval = setInterval(async () => {
        await this.getAllReports().then(response => {
          if (response?.data?.data?.every(item => item?._source?.status === 'completed')) {
            clearInterval(this.interval)
            this.$refs.dataProviderReport.load()
          }
        }).catch(() => {
          clearInterval(this.interval)
          this.$refs.dataProviderReport.load()
        })
      }, 10000)
    },
    async getAllReports () {
      const url = this.mountUrlAndParams('abandonmentReports').url
      const filters = this.mountUrlAndParams('abandonmentReports').filter
      return this.$axios.get(url, { params: filters })
    },
    closeModal () {
      this.displayAbandonmentReport = false
    },
    openCreateAbandonmentReportModal () {
      // if (item.data) {
      // this.abandonmentReportData = item.data
      this.displayAbandonmentReport = true
    },
    mountUrlAndParams (endpoint) {
      const from = this.dateInterval.timestamp1
      const to = this.dateInterval.timestamp2
      const select = this.dateInterval?.select?.value
      const menu = this.dateInterval.menu === this.$t('efficiency.all') ? '' : this.dateInterval.menu
      const submenu = this.dateInterval.submenu === this.$t('efficiency.all') ? '' : this.dateInterval.submenu
      const page = this.filter.page
      const perPage = this.filter.perPage

      const url = `${process.env.VUE_APP_REPORTS_BACKEND}/reports/${endpoint}`
      const filter = { to, from, select }

      if (endpoint === 'abandonmentReports') {
        filter.page = page
        filter.perPage = perPage
      } else {
        filter.menu = menu
        filter.submenu = submenu
      }
      return { url, filter }
    },
    formatLabels (item, index) {
      switch (index) {
        case 0:
          const statusValues = {
            completed: this.$t('efficiency.statusAvailable'),
            pending: this.$t('efficiency.statusProcessing'),
            error: this.$t('efficiency.statusError')
          }
          const status = item._source.status
          // this.statusIsPending = status !== 'completed'
          return statusValues[status]
        case 1:
          return moment(item._source.createdAt).format('DD/MM/YYYY HH:mm:ss')
        case 2:
          return item._source.createdBy.name
        case 3:
          return item._source.name
        default:
          return '-'
      }
    },
    async generateCSV (id) {
      try {
        const response = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/reports/abandonmentReports/${id}`)
        const { data } = response.data[0]._source

        const formatedData = []
        if (data?.length === 0) {
          formatedData.push({
            date: '',
            userName: '',
            businessArea: '',
            tema: '',
            subTema: '',
            hasCompletedFlow: ''
          })
        } else {
          let formatedObjt = {}
          data.forEach(item => {
            formatedObjt = {
              ...item,
              date: moment(item.date).format('DD/MM/YYYY HH:mm:ss')
            }
            formatedData.push(formatedObjt)
            formatedObjt = {}
          })
        }

        this.csvData = formatedData
        let timestamp = Date.now()
        this.csvName = `${timestamp}_${response.data[0]._source.name}`
        this.$nextTick(() => {
          document.querySelector(`#${this.csvComponentId}`).click()
        })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('localDataTable.errorGeneratingCsv')
        })
      }
    },
    async mountChartData (key, response) {
      let itemArr = []
      if (key === 'agvTimeConversation') {
        this.dataObj[key] = response.data.averageTimeConversations.toFixed(2)
      } else if (key === 'avgInteraction') {
        this.dataObj[key] = response.data.agvInteraction.toFixed(2)
      } else if (key === 'averageAttendedRatings') {
        this.dataObj[key] = response.data.totalMessage.toFixed(2)
      } else if (key === 'foundInformation' || key === 'notFoundInformation') {
        this.dataObj[key] = response.data.data.total
      } else if (key === 'amountEndConversationByUserOrInactive') {
        const closedByUser = response.data.data.filter(f => f.key === 'closedByUser')[0]
        const expiredOrUserInactivity = response.data.data.filter(f => f.key === 'expiredOrUserInactivity')[0]
        this.dataObj.amountEndConversationByInactive = expiredOrUserInactivity.total
        this.dataObj.amountEndConversationByUser = closedByUser.total
      } else if (key === 'amountInformationFoundAndNotFound') {
        this.dataObj[key].data.labels = []
        this.dataObj[key].data.series[0] = []
        this.dataObj[key].data.series[1] = []
        response.data.data.forEach(row => {
          const dataArray = row.key.split('-')
          this.dataObj[key].data.labels.push(`${dataArray[1]}/${dataArray[0]}`)
          this.dataObj[key].data.series[0].push({
            meta: row.subtopics[0].key,
            value: row.subtopics[0].total ?? 0
          })
          this.dataObj[key].data.series[1].push({
            meta: row.subtopics[1].key,
            value: row.subtopics[1].total ?? 0
          })
        })
      } else if (key === 'percentInformationFoundByMainMenu') {
        let maxSize = 0
        this.dataObj[key].data.labels = []
        this.dataObj[key].data.series[0] = []
        this.dataObj[key].data.series[1] = []
        response.data.data.forEach(row => {
          this.dataObj[key].data.labels.push(row.key)
          this.dataObj[key].data.series[0].push({
            meta: row.subtopics[0].key,
            value: row.subtopics[0].total ?? 0
          })
          this.dataObj[key].data.series[1].push({
            meta: row.subtopics[1].key,
            value: row.subtopics[1].total ?? 0
          })
          if (row.key.length > maxSize) {
            maxSize = row.key.length
          }
        })
        const deltaSize = maxSize * 8
        this.dataObj[key].options.axisY.offset = deltaSize
        if (deltaSize < 100) {
          this.dataObj[key].options.axisY.offset = 100
        }
        if (deltaSize > 250) {
          this.dataObj[key].options.axisY.offset = 250
        }
      } else if (key === 'percentInformationFoundBySubmenu') {
        let maxSize = 0
        this.dataObj[key].options.axisY.offset = 100
        this.dataObj[key].options.height = 300
        this.dataObj[key].data.labels = []
        this.dataObj[key].data.series[0] = []
        this.dataObj[key].data.series[1] = []
        response.data.data.forEach(row => {
          this.dataObj[key].data.labels.push(row.key)
          this.dataObj[key].data.series[0].push({
            meta: row.subtopics[0].key,
            value: row.subtopics[0].total ?? 0
          })
          this.dataObj[key].data.series[1].push({
            meta: row.subtopics[1].key,
            value: row.subtopics[1].total ?? 0
          })
          if (row.key.length > maxSize) {
            maxSize = row.key.length
          }
        })
        const totalRows = response.data.data.length
        if (totalRows > 14) {
          this.dataObj[key].options.height = 40 * totalRows
        }
        const deltaSize = maxSize * 8
        this.dataObj[key].options.axisY.offset = deltaSize
        if (deltaSize < 100) {
          this.dataObj[key].options.axisY.offset = 100
        }
        if (deltaSize > 250) {
          this.dataObj[key].options.axisY.offset = 250
        }
      } else if (key === 'qtyConversationsHourWeek') {
        let seriesArr = []
        for (let i = 0; i < response.data[key].length; i++) {
          for (let j = 0; j < response.data[key][i].length; j++) {
            let value = response.data[key][i][j]
            itemArr.push({
              meta: `${j}h`,
              value: value
            })
          }
          seriesArr.push(itemArr)
          itemArr = []
        }
        this.dataObj[key].data.series = seriesArr
      } else if (key === 'amountAccessByMainMenu') {
        this.dataObj[key].data.labels = []
        this.dataObj[key].data.series[0] = []
        response.data.data.reverse().forEach(row => {
          this.dataObj[key].data.labels.push(row.key)
          this.dataObj[key].data.series[0].push({
            meta: row.key,
            value: row.total
          })
        })
      } else if (key === 'amountAccessBySubmenu') {
        this.dataObj[key].options.height = 345
        this.dataObj[key].data.labels = []
        this.dataObj[key].data.series[0] = []
        response.data.data = response.data.data.sort((a, b) => (a.total - b.total))
        response.data.data.forEach(row => {
          this.dataObj[key].data.labels.push(row.key)
          this.dataObj[key].data.series[0].push({
            meta: row.key,
            value: row.total
          })
        })
        const totalRows = response.data.data.length
        if (totalRows > 14) {
          this.dataObj[key].options.height = 40 * totalRows
        }
      } else if (key === 'notFoundInformationCloudWords') {
        this.dataObj[key].words = response.data.wordsCloud
      } else if (key === 'channel' || key === 'os') {
        const labels = response.data.dataLabels.labels.map(elem => {
          return this.capitalize(elem)
        })
        this.dataObj[key].data.label = labels
        this.dataObj[key].options.labels = labels
        if (labels.length === 1) {
          this.dataObj[key].options.classNames.label = 'onlyOneLabel'
        }
        for (let i = 0; i < response.data.dataSeries.series.length; i++) {
          let value = response.data.dataSeries.series[i]
          itemArr.push({
            meta: labels[i],
            value: value
          })
        }
        this.dataObj[key].data.series = itemArr
      } else if (key === 'os') {
      } else {
        this.dataObj[key] = response.data[key]
      }
    },
    mountTooltip (meta, value) {
      let tooltipMeta = "<span style='font-weight: bold'>" + meta + '</span>'
      let tooltipValue = '<span> Valor: ' + value + '</span>'
      return tooltipMeta + '<br/>' + tooltipValue
    },
    capitalize (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    labelColor (index) {
      switch (index) {
        case 0:
          return 'text-info'
        case 1:
          return 'text-danger'
        case 2:
          return 'text-warning'
        case 3:
          return 'text-primary'
        case 4:
          return 'text-success'
        case 5:
          return 'text-dribbble'
        case 6:
          return 'text-tumblr'
      }
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    }
  },
  mixins: [isTenantMixin],
  created () {
    this.dateInterval = {
      timestamp1: moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
      timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    }
  }
}
</script>
<style>
.wordCloud {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 7px;
  background-color: whitesmoke;
}

#reports .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line {
  height: 110px !important;
}

#reports .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__paragraph {
  padding-left: 4px !important;
}

.text-dribbble {
  color: #ea4c89;
}

.text-tumblr {
  color: #3c4858;
}

/* .ct-series.ct-series-a .customLine {
  stroke: #8FB9AA !important;
} */

.ct-series.ct-series-b .customLine {
  stroke: red !important;
}

.ct-bar-custom-a {
  fill: none;
  stroke-width: 10px;
  stroke: #36A1EB !important;
}

.efficiencyChart .ct-series-a .ct-label {
  stroke: #36A1EB !important;
  stroke-width: 1px;
  font-size: 0.875rem;
  line-height: 1;
}

.efficiencyChart .ct-series-b .ct-label {
  stroke: #3245B1 !important;
  stroke-width: 1px;
  font-size: 0.875rem;
  line-height: 1;
}

.efficiencyChart .ct-series-a .ct-bar {
  stroke: #36A1EB;
}

.efficiencyChart .ct-series-b .ct-bar {
  stroke: #3245B1 !important;
}

.color-green-olive {
  color: #3245B1;
}

.color-green-50 {
  color: #36A1EB;
}
</style>
